// Updated data file showing only license data
const licenseBarChartData = {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Licenses Issued",
      data: [90, 120, 100, 140, 130, 110, 150, 140, 130, 160, 170, 180],
      backgroundColor: "rgba(75, 192, 192, 0.6)",
      borderColor: "rgba(75, 192, 192, 1)",
      borderWidth: 1,
    },
  ],
};

export default licenseBarChartData;
